import React from 'react'
import clsx from 'clsx'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { StaticImage, getImage } from 'gatsby-plugin-image'
import { BgImage } from 'gbimage-bridge'

import HeroCarousel from '../../components/HeroCarousel'
import PressCoverage from '../../components/PressCoverage'
import Explainer from '../../components/Explainer'
import Pricing from '../../components/Pricing'

import * as styles from './Home.module.css'

function Home() {
  const data = useStaticQuery(graphql`
    {
      bgCarouselA: file(
        relativePath: {
          eq: "carousel/danielle-macinnes-RqgWDJFq6i0-unsplash.jpg"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      bgCarouselB: file(
        relativePath: { eq: "carousel/sai-de-silva-YLMs82LF6FY-unsplash.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      bgCarouselC: file(
        relativePath: { eq: "carousel/brett-jordan-ZaUE1SCHAaw-unsplash.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  `)

  return (
    <article className={styles.home}>
      <div className="et_pb_section et_pb_section_parallax et_pb_fullwidth_section">
        <HeroCarousel>
          <BgImage
            className="et_pb_slide et_pb_bg_layout_dark et_pb_media_alignment_center"
            image={getImage(data.bgCarouselA)}
          >
            <div
              className={clsx('et_pb_container', 'clearfix', styles.callouter)}
            >
              <div className={clsx('et_pb_slide_description', styles.callout)}>
                <div className="et_pb_slide_content">
                  <h1>
                    <b>Create your basic legal will today for free.</b>
                  </h1>
                </div>
                <a
                  href="https://app.affio.co.uk/#/register"
                  className="et_pb_more_button"
                >
                  Click here to start
                </a>
              </div>
            </div>
          </BgImage>
          <BgImage
            className="et_pb_slide et_pb_bg_layout_dark et_pb_media_alignment_center"
            image={getImage(data.bgCarouselB)}
          >
            <div
              className={clsx('et_pb_container', 'clearfix', styles.callouter)}
            >
              <div className={clsx('et_pb_slide_description', styles.callout)}>
                <div className="et_pb_slide_content">
                  <h2>
                    <b>Peace of mind shouldn’t cost you anything!</b>
                  </h2>
                </div>
                <a
                  href="https://app.affio.co.uk/#/register"
                  className="et_pb_more_button"
                >
                  Click here to start
                </a>
              </div>
            </div>
          </BgImage>
          <BgImage
            className="et_pb_slide et_pb_bg_layout_dark et_pb_media_alignment_center"
            image={getImage(data.bgCarouselC)}
          >
            <div
              className={clsx('et_pb_container', 'clearfix', styles.callouter)}
            >
              <div className={clsx('et_pb_slide_description', styles.callout)}>
                <div className="et_pb_slide_content">
                  <h2>
                    <b>Making your will is simple with Affio.</b>
                  </h2>
                </div>
                <a
                  href="https://app.affio.co.uk/#/register"
                  className="et_pb_more_button"
                >
                  Click here to start
                </a>
              </div>
            </div>
          </BgImage>
        </HeroCarousel>
      </div>
      <div className="et_pb_section" style={{ backgroundColor: '#ffffff' }}>
        <PressCoverage />
      </div>
      <div
        id="how"
        className="et_pb_section security"
        style={{ backgroundColor: '#ffffff' }}
      >
        <Explainer />
      </div>
      <div
        id="why"
        className="et_pb_section"
        style={{ backgroundColor: '#d8efe9' }}
      >
        <div className="et_pb_row">
          <div className="et_pb_column et_pb_column_1_2">
            <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
              <h2>
                <Link to="/why-make-a-will">Why make a Will?</Link>
              </h2>
              <p>
                We all know that making a Will is important and it’s not
                something we should keep putting off, but why? It is only by
                making a Will that you get to choose what happens to the things
                that matter to you. You get to decide who your estate will be
                left to and who will look after your children.
              </p>
              <p>
                <a className="hover:underline" href="/why-make-a-will">
                  Learn more about why you should make a Will
                </a>
              </p>
            </div>
          </div>
          <div className="et_pb_column et_pb_column_1_2">
            <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
              <StaticImage
                src="../../images/tablet-preview.png"
                alt="Preview"
                className="aligncenter size-full"
                objectFit="contain"
                width={445}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="et_pb_section security"
        style={{ backgroundColor: '#ffffff' }}
      >
        <div className="et_pb_row">
          <div className="et_pb_column et_pb_column_1_2">
            <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
              <StaticImage
                src="../../images/icons/lock.png"
                alt="Security"
                className="aligncenter size-full"
                style={{ display: 'block' }}
                objectFit="none"
              />
            </div>
          </div>
          <div className="et_pb_column et_pb_column_1_2">
            <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
              <h2 style={{ textAlign: 'left' }}>Top grade security.</h2>
              <p>
                We use bank levels of encryption provided by leading security
                experts to protect your information.
                <br />
                We will never release your data to a third party. We are
                regulated by the Information Commissioner under the Data
                Protection Act.
              </p>
              <p>
                Your payment details are securely handled by our
                industry-leading payment services provider.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        id="price"
        className="et_pb_section security"
        style={{ backgroundColor: '#ffffff' }}
      >
        <Pricing />
      </div>
    </article>
  )
}

export default Home
